export const Logo = ({ light = false, size = 40, sub = true }) => (
  <div className="flex items-center gap-2.5" data-testid="brand-logo">
    <div className="rounded-full bg-white grid place-items-center shrink-0 overflow-hidden" style={{ width: size, height: size }}>
      <img src="/brand/logo.png" alt="Dexterity Consult" className="w-[82%] h-[82%] object-contain" />
    </div>
    <div className="leading-none">
      <div className={`font-serif-dx text-[15px] sm:text-lg lg:text-base tracking-[0.06em] whitespace-nowrap ${light ? "text-white" : "text-[#5B2A6E]"}`}>DEXTERITY <span className="text-[#D4AF37]">CONSULT</span></div>
      {sub && <div className={`hidden sm:block text-[8px] lg:text-[7px] tracking-[0.16em] lg:tracking-[0.12em] uppercase mt-1 whitespace-nowrap ${light ? "text-[#D4AF37]" : "text-[#8a7a92]"}`}>Consultants · Engineers · Strategists</div>}
    </div>
  </div>
);
